import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';

import { GeneralErrorMessage } from './components/GeneralErrorMessage';
import { Paypal } from './components/PayPal';
import { StripeCreditCard } from './components/StripeCreditCard';
import { StripeWallet } from './components/StripeWallet';
import { usePaymentMethods } from './hooks/usePaymentMethods';

export const PaymentMethods: React.FC<EmptyProps> = () => {
	const {
		data: { moreWaysExpanded, stripeWalletPaymentsEnabled },
		actions: { clickMoreWays },
	} = usePaymentMethods();

	return (
		<div className="flex flex-col gap-5 md:gap-7">
			<GeneralErrorMessage />
			<div className="flex flex-col gap-3">
				{stripeWalletPaymentsEnabled && <StripeWallet height={48} />}
				{!moreWaysExpanded && stripeWalletPaymentsEnabled && (
					<Button data-qa="more-ways-to-pay-button" variant="secondary" className="py-3" onClick={clickMoreWays}>
						{/* TODO: add to translation file when productized */}
						More ways to pay
					</Button>
				)}

				{moreWaysExpanded && (
					<>
						<Paypal height={48} />
						<StripeCreditCard />
					</>
				)}
			</div>
		</div>
	);
};
